import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=127f702a&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f702a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127f702a')) {
      api.createRecord('127f702a', component.options)
    } else {
      api.reload('127f702a', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=127f702a&scoped=true&", function () {
      api.rerender('127f702a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UEdrliZaySFi/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports